import { CheckoutOrderTrialSummaryItemProps } from './checkout-order-trial-summary-item.props';
import LazyLoad from 'react-lazyload';
import React from 'react';
import { formatCurrency } from '../../../utils';

export const CheckoutOrderTrialSummaryItemMolecule = (
  props: CheckoutOrderTrialSummaryItemProps
) => {
  const cartTrial = props.cartTrials;
  const bundles = cartTrial.trial.bundles;
  const products = cartTrial.trial.products;

  return (
    <div data-cy="checkout-order-trial-summary-item-molecule">
      {bundles.length > 0 &&
        bundles.map((bundle, index) => (
          <div key={index} className="flex justify-between items-center mt-3">
            <LazyLoad offset={100}>
              <img
                className="image -m-1.5"
                alt={bundle.bundle?.title}
                src="https://app.hiwaldo.com/assets/images/eyecare-starter-kit.png"
                width={87}
                height={87}
              />
            </LazyLoad>
            <p className="font-waldo-sans w-28 text-base font-semibold md:w-36 md:text-xl">
              {bundle.quantity}x {bundle.bundle?.title}
            </p>
            <div
              className="trash-bin cursor-pointer"
              onClick={() => props.clearCartTrial()}
            >
              <LazyLoad offset={100}>
                <img
                  src="/images/icons/trash.svg"
                  alt="Bin"
                  width={15}
                  height={15}
                />
              </LazyLoad>
            </div>
            {!index && (
              <p className="text-base font-semibold text-uppercase text-waldo-sans md:text-xl">
                {formatCurrency(cartTrial.itemPrice as number, 2, 2)}
              </p>
            )}
          </div>
        ))}

      {bundles.length <= 0 &&
        products &&
        products.map((product, index) => (
          <div key={index} className="flex justify-between items-center my-3">
            <LazyLoad offset={100}>
              <img
                className="image -m-1.5"
                alt={product.product.title}
                src={product.product.primaryVariant?.assets[0].asset.path}
                width={87}
                height={87}
              />
            </LazyLoad>
            <p className="font-waldo-sans w-28 text-base font-semibold md:w-36 md:text-xl">
              {product.quantity}x {product.product.title}
            </p>
            <div
              className="trash-bin cursor-pointer"
              onClick={() => props.clearCartTrial()}
            >
              <LazyLoad offset={100}>
                <img
                  src="/images/icons/trash.svg"
                  alt="Bin"
                  width={15}
                  height={15}
                />
              </LazyLoad>
            </div>
            <p className="text-base font-semibold text-uppercase text-waldo-sans md:text-xl">
              {formatCurrency(cartTrial.itemPrice as number, 2, 2)}
            </p>
          </div>
        ))}
    </div>
  );
};
